/**
 * The Yamas mark.
 *
 * One shape doing two jobs: the letter Y, and a map pin. The arms open upward
 * like a signal being received, the stem drops to a point where the vehicle is,
 * and the ring at the junction is the pin's eye. It has to survive being drawn
 * at 16px in a browser tab, so it is three strokes and a ring — nothing that
 * turns to mud when it shrinks.
 */
export function LogoMark({ size = 24, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth={2.4}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M6.2 4.4 L12 11" />
      <path d="M17.8 4.4 L12 11" />
      <path d="M12 11 V 19.8" />
      <circle cx="12" cy="11" r="2.9" fill="currentColor" stroke="none" />
      <circle cx="12" cy="11" r="1.15" fill="var(--brand-500)" stroke="none" />
    </svg>
  );
}

/** The mark in its gradient badge, as it appears in the header and on sign-in. */
export function LogoBadge({ size = 30 }: { size?: number }) {
  return (
    <span className="brand-mark" style={{ width: size, height: size }}>
      <LogoMark size={Math.round(size * 0.62)} />
    </span>
  );
}

/** Mark plus wordmark. */
export function Logo({ size = 30 }: { size?: number }) {
  return (
    <div className="brand">
      <LogoBadge size={size} />
      <span className="wordmark">Yamas</span>
    </div>
  );
}
